import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { matchWorldSlug, redirectLegacyWorldHash } from "./worlds/registry";
// Statically imported (under 1 KB, and the registry it needs is already in this chunk).
// Behind its own dynamic import it put a second SERIAL round-trip in front of every
// world: entry -> WorldHost -> world. Now the world's chunk is the only hop.
import WorldHost from "./worlds/WorldHost";

const root = createRoot(document.getElementById("root")!);

// Wave-1 published `#/world/<slug>` and `#/w/<slug>`. Both now land on `/w/<slug>`,
// rewritten before anything mounts so the world sees only the canonical URL.
redirectLegacyWorldHash();

const worldSlug = matchWorldSlug();

if (worldSlug) {
  // A Fable World owns the whole document. The Foundry/showcase stylesheets and bundle
  // are behind a dynamic import that is never reached on this branch, so a world page
  // downloads neither.

  // Announce the route synchronously, before the first paint. This is NOT `data-world`:
  // that attribute is the "the world's DOM is on screen" signal and is still set from
  // inside the Suspense boundary (see WorldHost). This one only says which world is being
  // fetched, so the document-level rules in index.html that a world needs at first paint
  // (its body reset) do not have to wait for the world's chunk. See FW-11.
  document.documentElement.setAttribute("data-world-route", worldSlug);
  root.render(
    <StrictMode>
      <WorldHost slug={worldSlug} />
    </StrictMode>
  );
} else {
  void import("./App").then(({ default: App }) => {
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  });
}
